import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { ftlConfigV2 } from 'src/environments/environment';

@Component({
    selector: 'app-ftl',
    template: ''
})
export class FtlComponent implements OnInit {
  // constructor(
  //   private redirectService: RedirectService,
  //   private route: ActivatedRoute
  // ) {
  //   this.route.queryParams.subscribe(async (params) => {
  //     const inApp = params['inApp'];
  //     if (inApp) {
  //       ftlConfig.redirectUri = ftlConfig.redirectUri + '?inApp=true';
  //     }
  //   });
  // }
  // ngOnInit(): void {
  //   this.redirectService.redirect(ftlConfig.redirectUri);
  // }
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];

      if (inApp) {
        ftlConfigV2.redirectUri = ftlConfigV2.redirectUri + '&inApp=true';
      }
      //ftlConfigV2.redirectUri = ftlConfigV2.redirectUri + '&klarFlow=true'
    });
  }

  ngOnInit(): void {
    this.loginService.login(ftlConfigV2);
  }
}
